module.exports = function sorterRoutesByShortName(routes){
    var sorter = function(route1, route2){  // should be in urbiplanApiRoute
        return route1.getShortName().localeCompare(route2.getShortName(), undefined, {numeric: true, sensitivity: 'base'})
 }
 return routes.sort(sorter);
}
